import { createContext } from 'react'

export const HomeContext = createContext()
export const CommonEntryContext = createContext()
export const ClassViewContext = createContext()
export const ExplorePageContext = createContext()
export const ProgramContext = createContext()
export const ProgramViewContext = createContext()
export const ProgramsHomeContext = createContext()
export const MyPracticeDetailsContext = createContext()
